.meter {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  width: 100%;
  min-width: 220px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: var(--space-1) var(--space-4);
  font-size: var(--type-body-sm-size);
  line-height: var(--type-body-sm-line);
}

.label {
  color: var(--color-text-primary);
  font-weight: var(--weight-medium);
}

.value {
  color: var(--color-text-secondary);
  font-variant-numeric: tabular-nums;
}

.track {
  position: relative;
  height: 8px;
  overflow: hidden;
  border-radius: var(--radius-pill);
  background: var(--color-meter-track);
}

.fill {
  position: absolute;
  inset: 0 auto 0 0;
  width: calc(var(--ratio) * 100%);
  border-radius: var(--radius-pill);
  background: var(--color-meter-fill);
}

.track[data-level='warning'] {
  background: var(--color-meter-track-warning);
}

.track[data-level='warning'] .fill {
  background: var(--color-meter-fill-warning);
}

.track[data-level='danger'] {
  background: var(--color-meter-track-danger);
}

.track[data-level='danger'] .fill {
  background: var(--color-meter-fill-danger);
}

@media (forced-colors: active) {
  .track {
    border: 1px solid CanvasText;
  }

  .fill {
    background: Highlight;
  }
}
